import { render } from "./kalio-pagination.vue?vue&type=template&id=578d166e"
import script from "./kalio-pagination.vue?vue&type=script&lang=js"
export * from "./kalio-pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__